const qs = require('qs');

const linkWithFilter = ({ page, category }) => {
	const pieces = ['resource-library', category || 'all'];
	if (pieces[pieces.length - 1] === 'all') pieces.pop();
	if ((page || 1) !== 1) pieces.push(page);
	return `/${pieces.join('/')}`;
};

/// filters is an object with following fields: { query, page }
const queryParamsFromFilters = (filters, replacement) => {
	const finalFilters = replacement ? { ...filters, ...replacement } : filters;
	const params = Object.keys(finalFilters)
		.filter(key => (key === 'page' && (finalFilters[key] || 1) !== 1) || (key !== 'page' && !!finalFilters[key]))
		.reduce((acc, k) => Object.assign(acc, { [k] : finalFilters[k] }), {});
	return qs.stringify(params);
}

const linkWithQueryParams = params => `/resource-library${ params ? '?' : '' }${ params }`;

const capitalize = word => word.split('_').map(w => w.charAt(0).toUpperCase() + w.substring(1)).join(' ');
const audienceTitle= audience => `For ${capitalize(audience)}`;

const categories = {
	me: [
		'understanding_eating_disorders',
		'seeking_treatment',
		'self_help',
		'personal_stories',
	],
	carers: [
		'understanding_eating_disorders',
		'supporting_someone_with_an_eating_disorder',
		'personal_stories',
		'seeking_treatment',
	],
	researchers: [
		'publications',
	],
	service_development: [
		'forums',
		'guidelines',
		'nsw_updates',
	],
	professionals: [
		'screening_and_assessment',
		'understanding_eating_disorders',
		'treatment',
		'guidelines',
		'client_handouts',
		'elearning'
	],
};

const audiences = Object.keys(categories);
const audienceTitles = audiences
  .reduce((acc, next) => ({...acc, [next]: audienceTitle(next)}), {});
const typeTitle = type => capitalize(type)
  .replace(' And ', ' and ')
  .replace(' An ', ' an ')
  .replace(' With ', ' with ')
  .replace('Nsw', 'NSW')
  .replace('Elearning', 'eLearning');
const typeTitles = audiences
  .reduce((acc, next) => [...acc, ...categories[next]], [])
  .reduce((acc, next) => ({...acc, [next]: typeTitle(next)}), {});

module.exports = {
	// Takes the type field like 'inside-out-publications' and swaps dashes for spaces so it can
	// be displayed nicely in the tile.
	typeToDescription: type => {
		// For branding reasons
		if (type === 'inside-out-publication') return 'InsideOut Publication';
		if (type === 'eLearning') return 'eLearning';

		// fact-sheet becomes Fact Sheet
		return type
			.split('-')
			.map(word => word.charAt(0).toUpperCase() + word.substring(1))
			.join(' ');
	},

	categories,
	audiences,
	audienceTitles,
	typeTitles,
	extractAudiences: itemCategories => audiences
	  .filter(audience => itemCategories && itemCategories[audience] != null && itemCategories[audience].enabled)
	  .map(audience => ({id: audience, title: audienceTitles[audience]})),
	extractTypes: itemCategories => audiences
		.filter(audience => itemCategories && itemCategories[audience] != null && itemCategories[audience].enabled)
		.map(audience => categories[audience]
			.filter(type => itemCategories[audience][type])
			.map(type => ({ audience, type }))
		)
		.reduce((acc, next) => [...acc, ...next], []),

	linkWithFilter,
	linkWithQueryParams,
	queryParamsFromFilters,
};



// WEBPACK FOOTER //
// ./src/managers/resourceLibraryManager.js